<template>
	<section class="app-banner" :data-without-margin="props.withoutMargin" style="overflow: hidden">
		<div class="app-banner__image-container">
			<div :data-aos="disableAos ? undefined : 'fade-up'">
				<h3 class="app-banner__title" data-aos-delay="100" v-html="detectNewline($t('components.application_banner.start_journey'))"></h3>
			</div>
			<ButtonPrimary class="app-banner__btn" href="https://aplikacja.carfree.pl/" target="_blank">{{
				$t('components.application_banner.btn_text')
			}}</ButtonPrimary>
			<GlobalImage class="app-banner__image" src="app-banner2.png" alt="app-banner" :height="440" />
			<GlobalImage class="app-banner__image app-banner__image--mobile" src="app-banner-mobile.png" alt="app-banner" :height="401" />
		</div>
		<div class="app-banner__download">
			<div class="app-banner__download-container">
				<p class="app-banner__download-text">{{ $t('components.application_banner.download_text') }}</p>
				<div class="app-banner__download-links">
					<NuxtLink to="https://apps.apple.com/pl/app/carfree-rent-a-car/id6802304361" rel="nofollow" target="_blank">
						<GlobalImage
							style="position: relative; z-index: 10; height: 40px; width: auto"
							src="app-store-x2.png"
							alt="app store"
							:height="80" />
					</NuxtLink>
					<NuxtLink to="https://play.google.com/store/apps/details?id=pl.carfree.app" rel="nofollow" target="_blank">
						<GlobalImage
							style="position: relative; z-index: 10; height: 40px; width: auto"
							src="google-play-x2.png"
							alt="google play"
							:height="80" />
					</NuxtLink>
				</div>
				<GlobalImage
					:data-aos="disableAos ? undefined : 'fade-up'"
					data-aos-delay="200"
					class="app-banner__download-image app-banner__download-image--phone1"
					src="app-banner-phone-1-x2.png"
					alt="phone"
					:width="842" />
				<GlobalImage
					:data-aos="disableAos ? undefined : 'fade-up'"
					data-aos-delay="300"
					class="app-banner__download-image app-banner__download-image--phone2"
					src="app-banner-phone-2-x2.png"
					alt="phone"
					:width="635" />
				<GlobalImage
					class="app-banner__download-image app-banner__download-image--mobile"
					src="app-banner-phone-mobile.png"
					alt="phones"
					:width="332" />
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
const props = defineProps<{
	withoutMargin?: boolean
	disableAos?: boolean
}>()
</script>

<style lang="scss" scoped src="./ApplicationBanner.scss"></style>
